export default __webpack_public_path__ + "static/media/thumb_En.b8ac3823.jpg";